var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Text } from '../../typography';
import { color } from '../../styles';
import Flyout from '../Flyout';
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  white-space: normal;\n  color: ", ";\n"], ["\n  position: relative;\n  display: inline-block;\n  white-space: normal;\n  color: ", ";\n"])), color('secondaryBrand'));
var flyoutStyle = {
    padding: '5px 10px',
    textAlign: 'center'
};
var DarkTooltip = function (props) {
    var Trigger = props.trigger;
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var showFlyout = function () { return !props.disabled && setIsOpen(true); };
    var hideFlyout = function () { return setIsOpen(false); };
    return (_jsx(Wrapper, __assign({ onMouseEnter: showFlyout, onMouseLeave: hideFlyout, onPointerLeave: hideFlyout, style: props.wrapperStyle }, { children: _jsx(Flyout, __assign({ reference: Trigger ? (_jsx(Trigger, { style: {
                    fill: isOpen
                        ? props.theme.color.secondaryBrand
                        : props.theme.color.grey,
                    marginTop: '-0.3rem'
                } })) : (props.children), visible: isOpen, style: flyoutStyle, shift: props.shift, placement: props.placement, width: props.width, trianglePosition: props.trianglePosition, backgroundColor: "secondaryBrand" }, { children: _jsx(Text, __assign({ size: "body2_new", as: "span", color: "white" }, (props.textProps || {}), { children: props.text })) })) })));
};
DarkTooltip.defaultProps = {
    placement: 'left',
    width: '10rem'
};
export default withTheme(DarkTooltip);
var templateObject_1;
//# sourceMappingURL=index.js.map